import React from 'react'
import { useFormContext } from 'react-hook-form'

import { useSelector } from 'react-redux'

import { Card } from '@/components/Elements'
import { NumberInput } from '@/components/Form'
import { offerQuotationGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerQuotationEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import { Button, Flex, Grid, Text } from '@chakra-ui/react'

const ContractInfo = ({ subSystemIndex, isNew = true }) => {
  const offerPermissions = useSelector(selectOfferPermissions)
  const { setValue, getValues } = useFormContext()

  //Translated
  const canEditSubSystem = offerPermissions[offerQuotationGroupPolicyType.QUOTATION_SUB_SYSTEM]?.edit ?? false

  const copyCurrentContractInfo = () => {
    const currentContractInfo = getValues(`subSystems.${subSystemIndex}.existingContractInfo`)
    setValue(`subSystems.${subSystemIndex}.renewContractInfo`, currentContractInfo)
  }

  return (
    <Card
      title="Contract Information"
      hasBorder={false}
      rightElement={
        canEditSubSystem && (
          <Button colorScheme="blue" onClick={() => copyCurrentContractInfo()}>
            Copy From Current
          </Button>
        )
      }
    >
      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb="2">
        <Text></Text>
        <Text>Current Contract</Text>

        <Text>{isNew ? 'New' : 'Renewal'} Contract</Text>
      </Grid>

      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb="2">
        <Flex gap="3">
          <Text>Number of Buildings</Text>

          <Text color="red">*</Text>
        </Flex>
        <NumberInput
          name={`subSystems.${subSystemIndex}.existingContractInfo.numberOfBuildings`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />
        <NumberInput
          name={`subSystems.${subSystemIndex}.renewContractInfo.numberOfBuildings`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />
      </Grid>

      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb="2">
        <Flex gap="3">
          <Text>Number of Floors</Text>

          <Text color="red">*</Text>
        </Flex>
        <NumberInput
          name={`subSystems.${subSystemIndex}.existingContractInfo.numberOfFloors`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />

        <NumberInput
          name={`subSystems.${subSystemIndex}.renewContractInfo.numberOfFloors`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />
      </Grid>

      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb="2">
        <Flex gap="3">
          <Text>Number of DDC</Text>

          <Text color="red">*</Text>
        </Flex>

        <NumberInput
          name={`subSystems.${subSystemIndex}.existingContractInfo.numberOfDDC`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />

        <NumberInput
          name={`subSystems.${subSystemIndex}.renewContractInfo.numberOfDDC`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />
      </Grid>

      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb="2">
        <Flex gap="3">
          <Text>Number of Devices (detectors /sensors .etc)</Text>

          <Text color="red">*</Text>
        </Flex>
        <NumberInput
          name={`subSystems.${subSystemIndex}.existingContractInfo.numberOfDevices`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />

        <NumberInput
          name={`subSystems.${subSystemIndex}.renewContractInfo.numberOfDevices`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />
      </Grid>

      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb="2">
        <Flex gap="3">
          <Text>Number of Panel</Text>

          <Text color="red">*</Text>
        </Flex>
        <NumberInput
          name={`subSystems.${subSystemIndex}.existingContractInfo.numberOfPanel`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />

        <NumberInput
          name={`subSystems.${subSystemIndex}.renewContractInfo.numberOfPanel`}
          type="number"
          placeholder="Enter value"
          disabled={!canEditSubSystem}
        />
      </Grid>
    </Card>
  )
}

export default ContractInfo
